<template>
  <div class="radio">
    <slot>
      <div class="radio-btn" @click="switchStatus">
        <img :src="radioStatusMap[radio.value]" />
      </div>
      <span
        class="radio-text"
        :class="radio.value ? 'active' : 'default'"
        v-text="radio.label"
      ></span>
    </slot>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import RadioActiveImg from './assets/radio-active.svg';
import RadioDefaultImg from './assets/radio-default.svg';

@Component({
  components: {
    RadioActiveImg,
    RadioDefaultImg,
  },
})
export default class Radios extends Vue {
  @Prop({ type: Object, default: {} }) radio!: {};
  radioStatusMap = {
    true: RadioActiveImg,
    false: RadioDefaultImg,
  };

  switchStatus() {
    this.$emit('switchStatus', this.radio);
  }
}
</script>

<style lang="scss" scoped>
.radio {
  display: flex;
  align-items: center;
  .radio-btn {
    width: 32px;
    height: 32px;
    object-fit: contain;
    font-weight: normal;
    font-size: 28px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    border-radius: 50%;
    img {
      width: 100%;
      border-radius: 50%;
    }
  }
  .radio-text {
    margin-left: 16px;
    &.default {
      color: #888585;
    }
    &.active {
      color: #6749ec;
    }
  }
}
</style>
